


































import { mapGetters, mapActions } from "vuex";
import { defineComponent } from "@vue/composition-api";
import Sidebar from "@c/molecules/app/Sidebar.vue";
import FloatMenu from "@c/molecules/place/FloatMenu.vue";
import useFetcher from "@use/useFetcher";

export default defineComponent({
  name: "Place",

  components: {
    Sidebar,
    FloatMenu
  },

  setup(props, { root }) {
    const place_id = parseInt(root.$route.params.id);

    var { entity: place, loading } = useFetcher("place/GET_PLACE", {action_param:place_id});

    return {
      place,
      loading
    };
  }
});
